"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_js_1 = require("./compression/index.js");

var defaultPoolSize = typeof navigator !== 'undefined' ? navigator.hardwareConcurrency || 2 : 2;
/**
 * @module pool
 */

/**
 * Pool for workers to decode chunks of the images.
 */

var Pool = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Number} [size] The size of the pool. Defaults to the number of CPUs
   *                      available. When this parameter is `null` or 0, then the
   *                      decoding will be done in the main thread.
   * @param {function(): Worker} [createWorker] A function that creates the decoder worker.
   * Defaults to a worker with all decoders that ship with geotiff.js. The `createWorker()`
   * function is expected to return a `Worker` compatible with Web Workers. For code that
   * runs in Node, [web-worker](https://www.npmjs.com/package/web-worker) is a good choice.
   *
   * A worker that uses a custom lzw decoder would look like this `my-custom-worker.js` file:
   * ```js
   * import { addDecoder, getDecoder } from 'geotiff';
   * addDecoder(5, () => import ('./my-custom-lzw').then((m) => m.default));
   * self.addEventListener('message', async (e) => {
   *   const { id, fileDirectory, buffer } = e.data;
   *   const decoder = await getDecoder(fileDirectory);
   *   const decoded = await decoder.decode(fileDirectory, buffer);
   *   self.postMessage({ decoded, id }, [decoded]);
   * });
   * ```
   * The way the above code is built into a worker by the `createWorker()` function
   * depends on the used bundler. For most bundlers, something like this will work:
   * ```js
   * function createWorker() {
   *   return new Worker(new URL('./my-custom-worker.js', import.meta.url));
   * }
   * ```
   */
  function Pool() {
    var _this = this;

    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultPoolSize;
    var createWorker = arguments.length > 1 ? arguments[1] : undefined;
    (0, _classCallCheck2.default)(this, Pool);
    this.workers = null;
    this._awaitingDecoder = null;
    this.size = size;
    this.messageId = 0;

    if (size) {
      this._awaitingDecoder = createWorker ? Promise.resolve(createWorker) : new Promise(function (resolve) {
        Promise.resolve().then(function () {
          return __importStar(require('./worker/decoder.js'));
        }).then(function (module) {
          resolve(module.create);
        });
      });

      this._awaitingDecoder.then(function (create) {
        _this._awaitingDecoder = null;
        _this.workers = [];

        for (var i = 0; i < size; i++) {
          _this.workers.push({
            worker: create(),
            idle: true
          });
        }
      });
    }
  }
  /**
   * Decode the given block of bytes with the set compression method.
   * @param {ArrayBuffer} buffer the array buffer of bytes to decode.
   * @returns {Promise<ArrayBuffer>} the decoded result as a `Promise`
   */


  (0, _createClass2.default)(Pool, [{
    key: "decode",
    value: function () {
      var _decode = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(fileDirectory, buffer) {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._awaitingDecoder) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this._awaitingDecoder;

              case 3:
                return _context.abrupt("return", this.size === 0 ? (0, index_js_1.getDecoder)(fileDirectory).then(function (decoder) {
                  return decoder.decode(fileDirectory, buffer);
                }) : new Promise(function (resolve) {
                  var worker = _this2.workers.find(function (candidate) {
                    return candidate.idle;
                  }) || _this2.workers[Math.floor(Math.random() * _this2.size)];

                  worker.idle = false;
                  var id = _this2.messageId++;

                  var onMessage = function onMessage(e) {
                    if (e.data.id === id) {
                      worker.idle = true;
                      resolve(e.data.decoded);
                      worker.worker.removeEventListener('message', onMessage);
                    }
                  };

                  worker.worker.addEventListener('message', onMessage);
                  worker.worker.postMessage({
                    fileDirectory: fileDirectory,
                    buffer: buffer,
                    id: id
                  }, [buffer]);
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function decode(_x, _x2) {
        return _decode.apply(this, arguments);
      }

      return decode;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.workers) {
        this.workers.forEach(function (worker) {
          worker.worker.terminate();
        });
        this.workers = null;
      }
    }
  }]);
  return Pool;
}();

exports.default = Pool;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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